<template lang="pug">
div
  v-row.mt-2.mb-0.ml-2.mt-4(align="center")
    v-col(cols="4" v-if="member.role === 'Admin'")
      v-select.mt-4(v-model="campaignId" item-text="title" item-value="id" :items="this.campaigns" outlined dense hide-details placeholder="All campaign")
        template(v-slot:append)
          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        template(v-slot:item="{ index, item, attrs }")
          div.py-2
            div.s1.mb-1(:class="attrs.inputValue ? 'black--text' : 'primary--text'") {{ item.title }}
    v-col(cols="8" align="right" v-if="member.role === 'Admin'")
      v-btn.my-auto.round-lg(color="primary" outlined height=32 @click="filterSheet = true" small)
        v-icon(left) mdi-chevron-down
        .s2.text-capitalize(v-if="selectedFilter.range.id !== 'custom'") {{ selectedFilter.range.name }}
        .s2.text-capitalize(v-else) {{ customDateFilterRangeFormatted }}
  v-row.mt-2.mb-0.ml-2.mt-4(v-if="this.metrics")
    v-col.mb-2(cols="3" v-if="member.role === 'Admin'")
      div 
        .s1.primary400--text {{ $t('total_donations') }}
        .h5 {{this.metrics.total | displayPrice}} 
    v-col(cols="3" v-if="member.role === 'Admin'")
      div 
        .s1.primary400--text {{ $t('total_donors') }}
        .h5 {{this.metrics.donor_count}} 
    v-col(cols="3" v-if="member.role === 'Admin'")
      div 
        .s1.primary400--text {{ $t('average_transaction') }}
        .h5 {{ this.metrics.average | displayPriceNoCent }} 
    v-col(cols="3")
      div(v-if="!isNaN(parseInt(this.metrics.progress))")
        .s1.primary400--text {{ $t('donation_progress') }}
        .h5 {{this.metrics.progress}} %
  v-row.mt-2.mb-0.mt-4(no-gutters)
    v-col(cols="12" v-if="member.role === 'Admin'")
      v-card(flat)
        apexchart(type="area" height="200", :options="chartOptions", :series="dataSeries")
  .modals
    filter-chart-sheet(v-if="filterSheet" :company="company" :filtered="selectedFilter" :open.sync="filterSheet" @filtered="handleFiltered")

</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterChartSheet from '@/components/donation/analytics/FilterChartSheet.vue'

export default {
  name: 'DonationChart',
  components: { FilterChartSheet },
  props: ['company'],
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    selectedFilter: {
      source: { name: 'All', id: '' },
      range: { name: 'This month', id: 'month' },
      selectedDateRange: []
    },
    customDateFilterMenu: false,
    customDateFilterRange: [],
    customDateFilterRangeFormatted: 'Date Range',
    filterSheet: false,
    filters: [
      {
        text: 'Day',
        value: 'day'
      },
      {
        text: 'Week',
        value: 'week'
      },
      {
        text: 'Month',
        value: 'month'
      },
      {
        text: 'Year',
        value: 'year'
      },
      {
        text: 'Date Range',
        value: 'custom'
      }
    ],
    campaignId: '',
    campaigns: [''],    
    metrics: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    chartOptions () {
      return {
        colors: [this.$vuetify.theme.themes[this.$theme].basic600T40],
        chart: {
          fontFamily: 'Inter',
          height: '100%',
          toolbar: {
            show: false
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 10,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false
        },
        fill: {
          type: 'solid'
        },
        yaxis: {
          labels: {
            formatter (value) {
              return isNaN(parseInt(value)) ? 100 : parseInt(value)
            }
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: {
            hideOverlappingLabels: true,
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM",
              day: 'dd/MM',
              hour: 'htt',
            }
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
        }
      }
    },
    dataSeries () {
      let data = []
      const formatPoint = p => ({
        x: (new Date(p.point)).getTime(),
        y: p.amount / 100
      })
      if (this.metrics) {
       data = this.metrics.points.map(p => formatPoint(p))
      }
      return [{
        name: 'Amount (RM)',
        type: 'column',
        data
      }]
    },
    pointDateFormat () {
      if (this.selectedFilter.range.id === 'day') {
        return 'ha'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'dd/MM'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'd'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'MMM'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'ha'
        } else {
          return 'dd/MM'
        }
      } else {
        return ''
      }
    },
    currentPointName () {
      if (this.selectedFilter.range.id === 'day') {
        return 'This hour'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'This day'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'This date'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'This month'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'This hour'
        } else {
          return 'This date'
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    company (val) {
      if (val) {
        this.fetchMetrics('month')
      }
    },
    campaignId (val) {
      this.fetchMetrics(this.selectedFilter.range.id, this.selectedFilter.selectedDateRange)
      this.selectCampaign(val)
    }
  },
  mounted () {
    this.fetchMetrics('month')
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleFiltered (data) {
      this.selectedFilter = data
      this.customDateFilterRangeFormatted = this.formatDateRange(data.selectedDateRange)
      this.fetchMetrics(data.range.id, data.selectedDateRange)
      this.$emit('spanChange', data)
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
    selectCampaign (val) {
      this.$emit('campaignChange', val)
    },
    fetchMetrics (span, range=null) {
      let url = `/donations/${this.company.slug}/charts/?span=${span}`
      if (span === 'custom') {
        url = `/donations/${this.company.slug}/charts/?span=custom&from=${range[0]}&until=${range[1]}`
      }
      url += `&campaign=${this.campaignId}`
      this.$axios.get(url)
        .then(resp => {
          this.campaigns = resp.data.campaigns
          this.campaigns.splice(0, 0, { title: 'All campaign', id: '' })
          this.metrics = resp.data
        })
        .catch(e => {
          this.showMessage(['error', e.response.data[0]])
        })
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style lang="css" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: transparent;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "donations": "Donations",
    "total_donations": "Total donations",
    "donation_progress": "Donation progress"
  },
  "id": {
    "donations": "Donasi",
    "total_donations": "Jumlah Donasi",
    "donation_progress": "Perkembangan Donasi"
  }
}
</i18n>